// extracted by mini-css-extract-plugin
export var currencyInput = "_o8-1";
export var currencySymbol = "_o8-0";